import { getProfileDataThunk, resetUserEmailOrPhoneThunk } from '../../../../../store/workspace/thunks';
import { setEditPhoneNumberModal } from '../../../../../store/workspace/slice';
import { EditSquareIcon, CheckSolidIcon } from '../../../../../assets/icons';
import PhoneNumberInput from '../../../../../components/PhoneNumberInput';
import { selectProfile } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import OTP from '../../../../../components/OTP';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

type Step = 'PhoneNumber' | 'Confirm' | 'Done';

export default function EditPhoneNumber() {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const profile = useSelector(selectProfile);
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState<Step>('PhoneNumber');
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>('');
    const [password, setPassword] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [responseError, setResponseError] = useState('');

    const submit = () => {
        if (!phoneNumber || !profile) return;

        switch (step) {
            case 'PhoneNumber':
                setIsLoading(true);
                dispatch(resetUserEmailOrPhoneThunk({
                    key: password,
                    email: profile.email,
                    newPhoneNumber: phoneNumber,
                }))
                    .unwrap()
                    .then((res) => {
                        setStep('Confirm');
                    })
                    .catch((err) => {
                        setResponseError(err?.message || 'Something went wrong,Try again...');
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
                break;
            case 'Confirm':
                setIsLoading(true);
                dispatch(resetUserEmailOrPhoneThunk({
                    key: password,
                    email: profile.email,
                    verificationCode: otp,
                    newPhoneNumber: phoneNumber,
                }))
                    .unwrap()
                    .then((res) => {
                        setStep('Done');
                        dispatch(getProfileDataThunk());
                    })
                    .catch((err) => {
                        setResponseError(err?.message || 'Something went wrong,Try again...');
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
                break;
            case 'Done':
                dispatch(setEditPhoneNumberModal(false))
                break;
        }
    };

    useEffect(() => {
        if (otp.length !== 6) return;
        submit();
    }, [otp]);

    return (
        <Modal
            size='sm'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            title='Edit phone number'
            closeFunc={() => dispatch(setEditPhoneNumberModal(false))}
        >
            {step === 'PhoneNumber' && (
                <>
                    <PhoneNumberInput
                        showErrorMessage
                        label='Phone number'
                        phoneNumber={phoneNumber}
                        setPhoneNumber={setPhoneNumber}
                        setIsValid={setIsValidPhoneNumber}
                    />
                    <Input
                        type='password'
                        value={password}
                        label='Current password'
                        onChange={setPassword}
                        error={passwordErrorMessage}
                    />
                </>
            )}

            {step === 'Confirm' && <div className={styles.confirm}>
                <span className={styles.description}>
                    Enter the sent code to:
                </span>
                <div className={styles.detail}>
                    <div className={styles.detail_phone}>
                        <span>{phoneNumber}</span>
                    </div>
                    <span
                        onClick={() => setStep('PhoneNumber')}
                        className={styles.detail_change_phone}
                    >
                        Change phone number
                    </span>
                </div>
                <OTP
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    onChangeRegex={/^([0-9]{0,})$/}
                />
            </div>}

            {step === 'Done' && <div className={styles.done}>
                <CheckSolidIcon />
                <span>
                    Phone number updated successfully
                </span>
            </div>}

            {responseError && <span className={styles.error}>{responseError}</span>}

            <div className={styles.actions}>
                <Button
                    type='Outline-Dark'
                    text='Cancel'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setEditPhoneNumberModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    onClick={submit}
                    disabled={!profile}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
